module.exports = function getResource(label, vars = []) {
    const resources = {
        seeProductDetails: 'Voir les détails du produit',
        appExclusive: 'Pour l’acheter, téléchargez ou ouvrez l’appli Sephora.',
        notRated: 'Aucune note',
        oneReview: 'Un commentaire',
        reviews: ' commentaires',
        productPreview: 'Aperçu du produit',
        viewDetails: 'Voir les détails'
    };

    return resources[label];
};
